export default "__VITE_PUBLIC_ASSET__5b4f491a__"